import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {StandardRequestHeadereHttpInterceptor} from "felles-ng2/infrastruktur/http/StandardRequestHeadereHttpInterceptor";
import {ApiVersjonResponsHeadereHttpInterceptor} from "felles-ng2/infrastruktur/http/ApiVersjonResponsHeadereHttpInterceptor";
import {HttpUnauthorizedEventVed401ResponsHttpInterceptor} from "felles-ng2/infrastruktur/http/HttpUnauthorizedEventVed401ResponsHttpInterceptor";


/**
 * Http interceptorer.
 * Første innslag blir evaluert først for request og sist for respons.
 * Se https://angular.io/guide/http-intercept-requests-and-responses for detaljer.
 */
export const httpInterceptorTilbydere = [
    //Notice the multi: true option. This required setting tells Angular that HTTP_INTERCEPTORS is a token for a multiprovider that injects an array of values, rather than a single value.

    //legger til faste http-headere nyttige for logging på serversiden
    {provide: HTTP_INTERCEPTORS, useClass: StandardRequestHeadereHttpInterceptor, multi: true},

    //legger til lesing av api-versjonsrelaterte headere i http-responser, med varsel ved utdatert klient
    {provide: HTTP_INTERCEPTORS, useClass: ApiVersjonResponsHeadereHttpInterceptor, multi: true},

    //broadcaster httpUnauthorizedEvent ved 401 respons
    {provide: HTTP_INTERCEPTORS, useClass: HttpUnauthorizedEventVed401ResponsHttpInterceptor, multi: true},

];
